/**
 * PKCE（RFC 7636）の verifier / challenge と state の生成。
 *
 * 乱数は WebCrypto から取る（`Math.random` は使わない）。challenge は S256 のみを
 * 作る。認可サーバーが `plain` も受けるとしても、こちらから弱い方を選ばない。
 */

const VERIFIER_BYTES = 32;
const STATE_BYTES = 16;

function base64UrlEncode(bytes: Uint8Array): string {
  let binary = "";
  for (const byte of bytes) {
    binary += String.fromCharCode(byte);
  }
  return btoa(binary)
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
}

function randomBase64Url(byteLength: number): string {
  const bytes = new Uint8Array(byteLength);
  crypto.getRandomValues(bytes);
  return base64UrlEncode(bytes);
}

export function createCodeVerifier(): string {
  return randomBase64Url(VERIFIER_BYTES);
}

export function createState(): string {
  return randomBase64Url(STATE_BYTES);
}

export async function deriveCodeChallenge(verifier: string): Promise<string> {
  const digest = await crypto.subtle.digest(
    "SHA-256",
    new TextEncoder().encode(verifier),
  );
  return base64UrlEncode(new Uint8Array(digest));
}

export const CODE_CHALLENGE_METHOD = "S256";
